import { Head } from '@inertiajs/react'
import type { ReactNode } from 'react'
import BewaveFooter from '@/components/public/BewaveFooter'
import PublicHeader from '@/components/public/PublicHeader'
import { AUTH_BACKDROP } from '@/components/public/publicShell'
import { cn } from '@/lib/utils'
import type { CityOption } from '@/types/publicSchool'

interface AuthLayoutProps {
  title: string
  /** Alimenta o filtro de cidade do header público, igual às outras páginas. */
  cities: CityOption[]
  children: ReactNode
}

/**
 * Casca das telas de autenticação — login, esqueceu senha, redefinir senha.
 *
 * Mesmo header e rodapé das páginas públicas, com a ilustração da marca ao fundo
 * do miolo. As três telas repetiam uma foto de banco de imagens por conta própria
 * e não tinham header nem rodapé — cada uma virava, sem querer, uma casca
 * diferente da área pública.
 */
export default function AuthLayout({
  title,
  cities,
  children,
}: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-bewave-surface text-gray-900 antialiased">
      <Head title={title} />

      <PublicHeader brandHref="/" cities={cities} />

      {/* Mesmo fundo do login do criador (CreatorShell) — ver AUTH_BACKDROP. */}
      <main
        className={cn(
          AUTH_BACKDROP,
          'flex flex-1 items-center justify-center px-5 py-12 sm:px-6',
        )}
      >
        {children}
      </main>

      <BewaveFooter />
    </div>
  )
}
